import Waypoints from 'waypoints/lib/noframework.waypoints.js'

/**
 * CenteredTextBlock functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class CenteredTextBlock {
  /**
   * Constructs a new HomeSection instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.siteBorder = document.querySelector('[data-component="site-border"]')
    this.fixedLogo = document.querySelector('[data-component="fixed-logo"]')
    this.scrollCta = document.querySelector('[data-component="scroll-cta"]')

    const self = this
    new Waypoint({
      element: self.element,
      handler: function(direction) {
        if (direction == 'down') {
          self.siteBorder.classList.add('visible')
          self.fixedLogo.classList.add('hidden')
          if (self.scrollCta) {
            self.scrollCta.classList.add('hidden')
          }
        } else {
          self.siteBorder.classList.remove('visible')
          self.fixedLogo.classList.remove('hidden')
          if (self.scrollCta) {
            self.scrollCta.classList.remove('hidden')
          }
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/centered-text-block/index.js